/* Modernizr 2.6.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransitions-input-testprop-testallprops-domprefixes-load
 */
;window.Modernizr=function(a,b,c){function w(a){i.cssText=a}function x(a,b){return w(prefixes.join(a+";")+(b||""))}function y(a,b){return typeof a===b}function z(a,b){return!!~(""+a).indexOf(b)}function A(a,b){for(var d in a){var e=a[d];if(!z(e,"-")&&i[e]!==c)return b=="pfx"?e:!0}return!1}function B(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:y(f,"function")?f.bind(d||b):f}return!1}function C(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+m.join(d+" ")+d).split(" ");return y(b,"string")||y(b,"undefined")?A(e,b):(e=(a+" "+n.join(d+" ")+d).split(" "),B(e,b,c))}function D(){e.input=function(c){for(var d=0,e=c.length;d<e;d++)q[c[d]]=c[d]in j;return q.list&&(q.list=!!b.createElement("datalist")&&!!a.HTMLDataListElement),q}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))}var d="2.6.2",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j=b.createElement("input"),k={}.toString,l="Webkit Moz O ms",m=l.split(" "),n=l.toLowerCase().split(" "),o={},p={},q={},r=[],s=r.slice,t,u={}.hasOwnProperty,v;!y(u,"undefined")&&!y(u.call,"undefined")?v=function(a,b){return u.call(a,b)}:v=function(a,b){return b in a&&y(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=s.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(s.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(s.call(arguments)))};return e}),o.csstransitions=function(){return C("transition")};for(var E in o)v(o,E)&&(t=E.toLowerCase(),e[t]=o[E](),r.push((e[t]?"":"no-")+t));return e.input||D(),e.addTest=function(a,b){if(typeof a=="object")for(var d in a)v(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},w(""),h=j=null,e._version=d,e._domPrefixes=n,e._cssomPrefixes=m,e.testProp=function(a){return A([a])},e.testAllProps=C,e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};

document.documentElement.className = ''; //Remove no-js class

$(function(){
    //Element randomiser
    $.fn.randomise = function(childElem) {
        function shuffle(array) {
            var tmp, current, top = array.length;
            if(top) while(--top) {
                current = Math.floor(Math.random() * (top + 1));
                tmp = array[current];
                array[current] = array[top];
                array[top] = tmp;
            }
            return array;
        }
    
      return this.each(function() {
          var $this = $(this);
          var elems = $this.children(childElem);
          elems = shuffle(elems);
          elems.find('script').remove(); //Don't trigger scripts again
          $this.remove(childElem);
          for(var i=0; i < elems.length; i++)
            $this.append(elems[i]);
      });
    }
    //Masonry plugin
    $(document).bind('buildmasonry', function(){
        var $container = $('.blocklayout');
      
      	//Clone and make sure everything's visible, ensures imagesLoaded is triggered when images might be hidden
	    var $containerClone = $container.clone();
      	$containerClone.find('*').show();
      
        $containerClone.imagesLoaded(function(){
            //Randomise, if it's meant to be randomised
            $('div.blocklayout.randomise').randomise('div.block:not(.notrandom)');
            
            $container.masonry({
                itemSelector : '.block',
                isAnimated: !Modernizr.csstransitions,
                columnWidth: function( containerWidth ) {
                    if($(window).width() <= 480) { //Under 480? Two-per-row instead
                        return containerWidth / 2;
                    } else if($(window).width() < 959) { //Under 959? Three-per-row instead
                        return containerWidth / 3;
                    } else {
                        return 250 + 10*2;
                    }
                } //Width of smallest block inc. margin/padding
            });
        });
    }).trigger('buildmasonry'); //First build
    $(window).load(function(){
        //Reflow masonry when fonts are loaded
        $('.masonry').masonry();
    });
    
    //An event to ensure the height of the sidebar is tall enough
    $(document).on('reup', '#navbar', function(){
        $(this).css('min-height', Math.max($(window).height(), $('#navpanel').outerHeight()));
    });
    //Upon every resize of the window
    $(window).resize(function() {
        $('#navbar').trigger('reup');
    });
    //Do now
    $('#navbar').trigger('reup');
    //And upon fonts/images loaded
    $(window).load(function() {
        $('#navbar').trigger('reup');
    });
    
    if(Modernizr.input.placeholder){
        //Placeholder text will vanish upon focus
        $('input[placeholder]').each(function(){
            $(this).data('placeholder', $(this).attr('placeholder'));
        });
        $(document).on('focusin', 'input[placeholder]', function(){
            $(this).attr('placeholder', '');
        }).on('focusout', 'input[placeholder]', function(){
            if($(this).val() == '' && typeof($(this).data('placeholder')) != 'undefined') {
                $(this).attr('placeholder', $(this).data('placeholder'));
            }
        });
    } else {
        //Simulate placeholder with JS
        $(document).on('focusin', 'input[placeholder]', function(){
            $(this).val('');
        }).on('focusout', 'input[placeholder]', function(){
            if($(this).val() == '' && typeof($(this).attr('placeholder')) != 'undefined') {
                $(this).val($(this).attr('placeholder'));
            }
        });
        $('input[placeholder]').trigger('focusout');
        $('input[placeholder]').parents('form').submit(function() {
            $(this).find('input[placeholder]').each(function() {
                var $input = $(this);
                if ($input.val() == $input.attr('placeholder')) {
                    $input.val('');
                }
            });
        });
    }
    
    //Simple button to expand/contract a div - also toggles text from show/hide
    $(document).on('click', '.togglebutton', function(){
        $btn = $(this);
        
        //Close any other buttons within group first
        if($btn.is('[data-exclusive-group]')) {
            $('[data-exclusive-group="'+$btn.data('exclusive-group')+'"]:not([data-target="'+$btn.data('target')+'"])').each(function(){
                $($(this).data('target')).hide();
                $(this).trigger('eval-toggle');
            });
        }
        
        $($(this).data('target')).toggle($(this).data('speed'), function(){
            $btn.trigger('eval-toggle');
            
            //Reload masonry if within it
            $(this).closest('.masonry').each(function(){
                $(this).masonry();
            });
        });
        return false;
    }).on('eval-toggle', '.togglebutton[data-text-hide]', function(){
        $tar = $($(this).data('target'));
        //Show/hide text
        if($tar.is(':visible')) {
            $(this).toggleClass('expanded', true).html($(this).data('text-hide'));
            if($(this).hasClass('quickbuytoggle')){ //quick-buy?
                $(this).parent().toggleClass('middle', true);
            }
        } else {
            $(this).toggleClass('expanded', false).html($(this).data('text-show'));
            if($(this).hasClass('quickbuytoggle')){
                $(this).parent().toggleClass('middle', false);
            }
        }
    });
    
    //Toggle nav on/off (aimed at portrait tablets to allow browsing more products)
    $('#content').data('defPadLeft', $('#content').css('padding-left'));
    $('#content').data('defPadTop', $('#content').css('padding-top'));
    $('#navbar').data('defWidth', $('#navbar').width());
    $(document).on('click', '#navtoggle', function(){
        //Animate to new positions, then trigger masonry change
        var newLeft = 0;
        var newPadding = $('#content').data('defPadLeft');
        if(!$('body').hasClass('nav-hidden')) {
            newLeft = -$('#navbar').data('defWidth');
            newPadding = $('#content').data('defPadTop');
        }
        
        $('#navbar').stop().animate({ left: newLeft }, 500);
        $('#content').stop().animate({ paddingLeft: newPadding }, 500, function(){
            if($('body').toggleClass('nav-hidden').hasClass('nav-hidden')) {
                $('#navtoggle').html('&rarr;');
            } else {
                $('#navtoggle').html('&larr;');
            }
            $('#navbar').css('left', '');
            $('#content').css('paddingLeft', '');
            
            //Change DOM to trigger reflow - avoiding webkit bug with div sizes not being recalculated
            $('.masonry').append('<span id="webkithackysack">&nbsp;</span>');
            $('.masonry').masonry();
            $('.masonry #webkithackysack').remove();
        });
        return false;
    });
    
    //Redirect dropdowns
    $(document).on('change', 'select.navdrop', function(){
        window.location = $(this).val();
    });
    
    //Scroll-to-top button for long pages
    $(window).scroll(function(){
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if(scrollTop > 500) {
        $('#scrolltotop').css('bottom', -8);
      } else {
        $('#scrolltotop').css('bottom', -100);
      }
    });
    $('#scrolltotop').click(function(){
        $('html:not(:animated),body:not(:animated)').animate({ scrollTop: 0}, 500 );
        return false;
    });
    
    //General purpose lightbox
    $('a[rel="fancybox"]').fancybox({ titleShow: false });
    
    //Main nav expanders
    $(document).on('click', '#navpanel .mainnav .title', function(){
        $(this).parent().addClass('active').siblings().removeClass('active');
        $('#navbar').trigger('reup'); //In case nav panel extended
    });
    $(document).on('click', '#navpanel .mainnav button', function(){
        //Prep animation on sublist
        if($(this).parent().hasClass('expanded')) {
            $(this).html('+');
            $(this).siblings('ul').stop(true,true).css('display', 'block').slideUp(300, 'linear', function(){
                $(this).parent().toggleClass('expanded');
                $('#navbar').trigger('reup');
            });
        } else {
            $(this).html('-');
            $(this).siblings('ul').stop(true,true).css('display', 'none').slideDown(300, 'linear', function(){
                $('#navbar').trigger('reup');
            });
            $(this).parent().toggleClass('expanded');
        }
        $('#navbar').trigger('reup'); //In case nav panel extended
    });
    $(document).on('click', '#navpanel .mainnav a[href="#"]', function(){
        $(this).siblings('button').trigger('click');
        return false;
    });
    
    //Search box, add focus class to wrapper
    $(document).on('focusin focusout','.panelinputblock .panelinputinner input.text', function(e){
        $(this).closest('.panelinputblock').toggleClass('focus', e.type == 'focusin');
    });
    
    //Show lightbox for any shrunken images inside certain areas
    var imageKeys = ['_pico.','_icon.','_thumb.','_small.','_compact.','_medium.','_large.','_grande.'];
    $('.lightboximages img').each(function(){
        if(!$(this).parent().is('a')) {
            var imgurl = $(this).attr('src');
            for(var i = 0; i < imageKeys.length; i++) {
                if(imgurl.indexOf(imageKeys[i]) > -1) {
                    imgurl = imgurl.replace(imageKeys[i], '.');
                    break;
                }
            }
            var $wrapa = $('<a>').attr('href', imgurl).addClass('fancyboximg');
            $(this).wrap($wrapa);
            $(this).parent().fancybox();
        }
    });
    
    
    
    
});